<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Etapa</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarEtapa(false)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
      </v-chip>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarEtapa(true)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
      </v-chip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col cols="3">
          <v-row justify="center" align="center" dense class="mx-4 mt-6 mb-2">

            <div v-if="modelEtapa.imagen_base64">
              <v-img :src="modelEtapa.imagen_base64" alt="Imagen de la etapa" width="200" height="200"
                style="border-radius: 10%;" class="mx-auto">
              </v-img>
            </div>

            <div v-else class="mr-4" style="width: 200px; height: 200px; background-color: white; border-radius: 10%;">
            </div>


          </v-row>

          <v-row dense class="mx-4 mt-6" justify="center" align="center">
            <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link
              @click="() => $refs.fileInput.click()">
              <span v-bind:style="{ color: 'white' }">Subir Imagen...</span>

            </v-chip>
           
            <input ref="fileInput" type="file" @change="onImageChange" style="display: none;" />
          </v-row>

        </v-col>
        <v-divider vertical></v-divider>
        <v-col class="ml-0">
          <v-row dense class="mx-4">
            <v-text-field v-model="modelEtapa.titulo" outlined label="Nombre" dense :dark="dark"
              autocomplete="off"></v-text-field>
          </v-row>

          <v-card class="mx-4">
            <v-card-title>
              <v-tabs v-model="tab" grow>
                <v-tab v-for="(language, index) in languages" :key="index">
                  {{ language }}
                </v-tab>
              </v-tabs>
            </v-card-title>

            <v-card-text>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card>
                    <v-card-text>
                      <v-row dense class="mx-2">
                        <v-textarea rows="10" outlined v-model="modelEtapa.descripcion" :dark="dark"
                          label="Descripcion"></v-textarea>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item>
                  <v-card>
                    <v-card-text>
                      <v-row dense class="mx-2">
                        <v-textarea rows="10" outlined v-model="modelEtapa.descripcion_EN" :dark="dark"
                          label="Descripcion"></v-textarea>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item>
                  <v-card>
                    <v-card-text>
                      <v-row dense class="mx-2">
                        <v-textarea rows="10" outlined v-model="modelEtapa.descripcion_DE" :dark="dark"
                          label="Descripcion"></v-textarea>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>

          <!-- <v-row dense class="mx-4 mt-6">
            <v-text-field v-model="modelEtapa.imagen_base64" outlined label="Imagen ..." dense :dark="dark"
              autocomplete="off"></v-text-field>

          </v-row> -->




          <v-row dense class="mx-4 mt-16">
            <v-combobox 
              outlined 
              dense 
              :dark="dark" 
              autocomplete="off" 
              v-model="modelEtapa.inicio_punto" 
              :search-input.sync="searchInicioPunto"
              label="Inicio"
              :items="puntos" 
              item-text="nombre" 
              item-value="id" 
              return-object
              hint="Seleccione o escriba un nuevo punto de inicio"
              persistent-hint>
            </v-combobox>
          </v-row>

          <v-row dense class="mx-4">
            <v-combobox 
              outlined 
              dense 
              :dark="dark" 
              autocomplete="off" 
              v-model="modelEtapa.final_punto" 
              :search-input.sync="searchFinalPunto"
              label="Final"
              :items="puntos" 
              item-text="nombre" 
              item-value="id" 
              return-object
              hint="Seleccione o escriba un nuevo punto final"
              persistent-hint>
            </v-combobox>
          </v-row>

          <v-row dense class="mx-4">
            <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelEtapa.dificultad" label="Dificultad"
              :items="['Fácil', 'Media', 'Difícil']"></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelEtapa.distancia"
              label="Distancia (Km)"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelEtapa.duracion"
              label="Duración (Horas)"></v-text-field>
          </v-row>


        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "EtapaFormulario",
  components: {},
  data: () => ({
    loading: false,
    tab: null,
    languages: ['Español', 'Inglés', 'Alemán'],
    searchInicioPunto: '',
    searchFinalPunto: '',

  }),

  props: {
    modelEtapa: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },

    camino: {
      type: Object,
      required: true,
    }
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("puntos", ["puntos", "puntoSelec"]),
    ...mapState("categorias", ["categorias"]),

  },

  watch: {
    'modelEtapa.inicio_punto': {
      immediate: true,
      handler(value) {
        this.searchInicioPunto = typeof value === 'string'
          ? value
          : value?.nombre || '';
      },
    },
    'modelEtapa.final_punto': {
      immediate: true,
      handler(value) {
        this.searchFinalPunto = typeof value === 'string'
          ? value
          : value?.nombre || '';
      },
    },
  },


  mounted() {
    this._getPuntos();
  },

  methods: {
    ...mapActions("etapas", ["getEtapas", "crearEtapa", "updateEtapa"]),
    ...mapActions("categorias", ["getCategorias"]),
    ...mapActions("puntos", ["getPuntos"]),

    _cerrarVentana() {
      this.$emit("soloCerrar", this.modelEtapa);
    },

    async _getPuntos() {
      await this.getPuntos([this.access_token, false]);
    },

    onImageChange(event) {
      const file = event.srcElement.files[0]; // Aquí se recibe el archivo directamente
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = () => {
            // Crear un canvas para recortar la imagen
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const canvasSize = 200;
            canvas.width = canvasSize;
            canvas.height = canvasSize;

            // Calcular las dimensiones para el recorte centrado
            const scale = Math.max(
              canvas.width / img.naturalWidth,
              canvas.height / img.naturalHeight
            );

            const x = (canvas.width - img.naturalWidth * scale) / 2
            const y = (canvas.height - img.naturalHeight * scale) / 2
            const width = img.naturalWidth * scale
            const height = img.naturalHeight * scale

            // Limpiar el canvas y dibujar la imagen centrada
            ctx.fillStyle = '#FFFFFF'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, x, y, width, height)

            this.modelEtapa.imagen_base64 = canvas.toDataURL('image/png');
          };

        };
        reader.readAsDataURL(file); // Lee el archivo como una URL de datos
      }
    },

    convertirImagen() {

    },

    async _guardarEtapa(cerrar) {
      this.loading = true;

      await this.$nextTick();
      
      // Preparar los datos de la etapa
      const etapaData = { ...this.modelEtapa };

      const inicioPuntoNombre = typeof etapaData.inicio_punto === 'string'
        ? etapaData.inicio_punto
        : etapaData.inicio_punto?.nombre;
      if (this.searchInicioPunto && this.searchInicioPunto !== inicioPuntoNombre) {
        etapaData.inicio_punto = this.searchInicioPunto;
      }
      
      // Si inicio_punto es un string (nuevo punto escrito), convertir a objeto con solo el nombre
      if (typeof etapaData.inicio_punto === 'string') {
        etapaData.inicio_punto = { nombre: etapaData.inicio_punto };
      }
      
      const finalPuntoNombre = typeof etapaData.final_punto === 'string'
        ? etapaData.final_punto
        : etapaData.final_punto?.nombre;
      if (this.searchFinalPunto && this.searchFinalPunto !== finalPuntoNombre) {
        etapaData.final_punto = this.searchFinalPunto;
      }

      // Si final_punto es un string (nuevo punto escrito), convertir a objeto con solo el nombre
      if (typeof etapaData.final_punto === 'string') {
        etapaData.final_punto = { nombre: etapaData.final_punto };
      }

      if (this.accion == "crear") {
        var res = await this.crearEtapa([
          this.access_token,
          etapaData,
          this.camino.id
        ]);
        const params = {};
        await this.getCategorias([this.access_token, false]);
      } else if (this.accion == "editar") {
        var res = await this.updateEtapa([
          this.access_token,
          etapaData,
        ]);
       
      }

      if (cerrar) {
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>
